import React from 'react';

function Pedagogy() {
  const pillars = [
    {
      title: '1. Architect-Led Cohorts',
      desc: 'Taught live by practicing principal engineers and architects. Small batches ensure your questions are answered and your architectural decisions are evaluated.',
      badge: 'Direct Faculty Interaction',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      )
    },
    {
      title: '2. Production Systems',
      desc: 'Build distributed key-value engines, raft consensus implementations, Kubernetes operators, and high-throughput order matching engines designed for real load.',
      badge: 'Zero Toy Projects',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
          <line x1="8" y1="21" x2="16" y2="21"></line>
          <line x1="12" y1="17" x2="12" y2="21"></line>
        </svg>
      )
    },
    {
      title: '3. Line-by-Line Code Review',
      desc: 'Every milestone submission is reviewed in private GitHub pull requests. Receive critical feedback on thread safety, cache locality, and idiomatic design.',
      badge: 'Weekly GitHub PR Feedback',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="6" y1="3" x2="6" y2="15"></line>
          <circle cx="18" cy="6" r="3"></circle>
          <circle cx="6" cy="18" r="3"></circle>
          <path d="M18 9a9 9 0 0 1-9 9"></path>
        </svg>
      )
    },
    {
      title: '4. Architecture Defense',
      desc: 'Graduate by defending your capstone project live before a panel of senior engineers. Demonstrate your trade-offs, benchmarking results, and failure recovery models.',
      badge: 'Verified Engineering Defense',
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
        </svg>
      )
    }
  ];

  return (
    <section className="pedagogy-section" id="pedagogy">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-tag">
            <span className="badge-pill badge-pill-cyan">Apprenticeship Model</span>
          </div>
          <h2 className="section-title">The Gurukulam Pedagogy</h2>
          <p className="section-desc">
            Passive video tutorials produce shallow knowledge. In engineering, mastery requires deep feedback loops, challenging reviews, and building real production systems.
          </p>
        </div>

        <div className="pillars-grid">
          {pillars.map((pillar, idx) => (
            <div className="pillar-card" key={idx}>
              <div className="pillar-icon-box">{pillar.icon}</div>
              <h3 className="pillar-title">{pillar.title}</h3>
              <p className="pillar-desc">{pillar.desc}</p>
              <span className="pillar-badge">{pillar.badge}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Pedagogy;
